import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import { type InPersonHostDefinedMeetingLocationData } from '@/Shared/AutoGenerated/Main'

export default class InPersonHostDefinedMeetingLocation {
    constructor(
        public readonly id: string,
        public readonly address: string,
        public readonly googleMapsUrl: string | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: InPersonHostDefinedMeetingLocationData,
    ): InPersonHostDefinedMeetingLocation {
        return new InPersonHostDefinedMeetingLocation(
            entityData.id,
            entityData.address,
            entityData.googleMapsUrl,
        )
    }

    static hydrateMultiple(
        entitiesData: InPersonHostDefinedMeetingLocationData[],
    ): InPersonHostDefinedMeetingLocation[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
